"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin: ", ";\n"], ["\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin: ", ";\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tpadding-right: 1em;\n\tflex: 3;\n\ttext-align: right;\n"], ["\n\tpadding-right: 1em;\n\tflex: 3;\n\ttext-align: right;\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tappearance: none;\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tbox-shadow: none;\n\tflex: 7;\n\tfont-family: sans-serif;\n\tfont-size: 1em;\n\tmargin: 0;\n\tmax-height: ", "em;\n\tpadding: ", ";\n\tpadding-left: 0;\n\ttext-indent: ", "em;\n\ttext-overflow: ellipsis;\n\twidth: 100%;\n\n\t&:focus {\n\t\toutline: none;\n\t}\n"], ["\n\tappearance: none;\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tbox-shadow: none;\n\tflex: 7;\n\tfont-family: sans-serif;\n\tfont-size: 1em;\n\tmargin: 0;\n\tmax-height: ", "em;\n\tpadding: ", ";\n\tpadding-left: 0;\n\ttext-indent: ", "em;\n\ttext-overflow: ellipsis;\n\twidth: 100%;\n\n\t&:focus {\n\t\toutline: none;\n\t}\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getters = require("../getters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --------------------------------------------------

var getInputMaxHeight = R.pipe(_getters.getPaddingVertical, R.multiply(2), R.add(1.2));

// --------------------------------------------------

var OuterWrapper = _styledComponents2.default.div(_templateObject, _getters.getMargin2);

var Label = _styledComponents2.default.div(_templateObject2);

var StyledInput = _styledComponents2.default.input(_templateObject3, _getters.getBorderRadius, (0, _getters.getColor)("gray"), getInputMaxHeight, _getters.getPadding2, _getters.getPaddingHorizontal);

// --------------------------------------------------

var Input = function Input(props) {
	var label = props.label,
	    rest = (0, _objectWithoutProperties3.default)(props, ["label"]);


	return _react2.default.createElement(
		OuterWrapper,
		null,
		label && _react2.default.createElement(
			Label,
			null,
			label
		),
		_react2.default.createElement(StyledInput, rest)
	);
};

Input.propTypes = {
	flavor: _propTypes2.default.oneOf(["BLACK", "WHITE", "TRANSPARENT"]),
	fullWidth: _propTypes2.default.bool,
	label: _propTypes2.default.string,
	message: _propTypes2.default.string,
	name: _propTypes2.default.string.isRequired,
	onChange: _propTypes2.default.func,
	onBlur: _propTypes2.default.func,
	placeholder: _propTypes2.default.string,
	required: _propTypes2.default.bool,
	type: _propTypes2.default.oneOf(["EMAIL", "PASSWORD", "TEXT"]),
	valid: _propTypes2.default.bool,
	value: _propTypes2.default.string
};

exports.default = Input;

//# sourceMappingURL=input.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/input.js
// module id = 374
// module chunks = 0